import type { paths } from './codegen/system.types'
import { HOST } from '@/globals/typescript/utils/host'
import { i18n } from '@/locales'
import { createLabApiClient } from '@team-milva/lab-utils'
import { getCurrentUserBearer } from './getCurrentUserBearer'

export const systemApi = createLabApiClient<paths>({
  baseUrl: `${HOST.functions}/system/v1`,
  defaultHeaders: () => {
    return {
      'Accept-Language': i18n.global.locale.value,
    }
  },
  getBearerToken: getCurrentUserBearer,
})

